var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-dialog',{attrs:{"titleHtml":_vm.title}},[_c('h2',[_vm._v("Lähtötiedoissa on puutteita")]),_vm._v(" "),_c('p',[_vm._v("Valitse kaikki lähtötietojen kohdat ja sen jälkeen korjaus.")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('img',{attrs:{"src":require("../../assets/huom_valitse.png")}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c65314f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/ParamsNotSetDialog.vue
// module id = null
// module chunks = 